import StakeModal from './StakeModal';
export default StakeModal;
